export const menuItems = [
  {
    id: "roadmap",
    label: "roadmap.text",
    icon: "mdi mdi-map-marker-distance",
    subItems: [
      {
        id: "platform-roadmap",
        label: "roadmap.platform.text",
        link: "/organization/roadmap",
      },
      {
        id: "kvkk-roadmap",
        label: "roadmap.kvkk.text",
        link: "/kvkk/roadmap",
      },
    ],
  },

  {
    id: "task",
    label: "task.plural",
    icon: "bx bx-task",
    link: "/task",
  },
  {
    id: "dashboard",
    label: "dashboard.text",
    icon: "bx bxs-dashboard",
    link: "/",
  },
  {
    id: "organization-schema",
    label: "organization.schema",
    icon: "mdi mdi-office-building",
    link: "/organization/unit-hierarchy",
  },
  {
    id: "department",
    label: "department.text",
    icon: "mdi mdi-office-building",
    link: "/department",
  },
  {
    id: "process",
    label: "process.text",
    icon: "mdi mdi-office-building",
    link: "/process",
  },
  {
    id: "datasource",
    label: "datasource.text",
    icon: "mdi mdi-office-building",
    link: "/datasource",
  },
  {
    id: "data",
    label: "data.text",
    icon: "mdi mdi-office-building",
    link: "/data",
  },
  {
    id: "data-category",
    label: "data-category.text",
    icon: "mdi mdi-office-building",
    link: "/data-category",
  },
  {
    id: "datasubject",
    label: "datasubject.text",
    icon: "mdi mdi-office-building",
    link: "/datasubject",
  },
  {
    id: "thirdparty",
    label: "thirdparty.plural",
    icon: "mdi mdi-office-building",
    link: "/organization/thirdparty",
  },

  {
    id: "inventory",
    label: "inventory.management",
    icon: "bx-data",
    subItems: [
      {
        id: "inventory.kvkk",
        label: "inventory.kvkk.text",
        link: "/kvkk/inventory",
      },
      {
        id: "physical-storage",
        label: "physical-storage.text",
        link: "/physical-storage",
      },
      {
        id: "electronic-storage",
        label: "electronic-storage.text",
        link: "/electronic-storage",
      },
      {
        id: "physical-archive",
        label: "physical-archive.text",
        link: "/physical-archive",
      },
    ],
  },
  {
    id: "announcement",
    label: "announcement.plural",
    icon: "bx bxs-megaphone",
    link: "/announcement",
  },
  {
    id: "fileManager",
    label: "file-manager.text",
    icon: "bx bxs-folder-open",
    link: "/organization/file-manager",
  },
  {
    id: "application",
    label: "application.text",
    icon: "bx bxs-book",
    link: "/organization/application",
  },
  {
    id: "minimization",
    label: "minimization.text",
    icon: "bx bxs-folder-open",
    link: "/kvkk/minimization",
  },
];
